import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=07d7bd84&scoped=true&"
var script = {}
import style0 from "./footer.vue?vue&type=style&index=0&id=07d7bd84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d7bd84",
  null
  
)

export default component.exports